export default "__VITE_ASSET__Bdo5jNBj__"